import { Box, Stack, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GeneralLedgerTable } from "../components";
import { BalanceSheet } from "../components/BalanceSheet";
import { IncomeStatement } from "../components/IncomeStatement";
import { TitheContributions } from "../components/TitheContributions";

function TabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`finance-tabpanel-${index}`}
      aria-labelledby={`finance-tab-${index}`}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const tabNames = [
  "trial-balance",
  "balance-sheet",
  "income-statement",
  "tithe-contributions"
];

export const Report = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    const path = location.pathname;
    const tabParam = path.split("/").pop();

    if (tabParam && tabNames.includes(tabParam)) {
      const tabIndex = tabNames.indexOf(tabParam);
      setActiveTab(tabIndex);
    } else if (path.endsWith("/report")) {
      navigate(`${path}/${tabNames[0]}`, { replace: true });
    }
  }, [location, navigate]);

  const handleTabChange = (event, newValue) => {
    const basePath = location.pathname.split("/").slice(0, -1).join("/");
    navigate(`${basePath}/${tabNames[newValue]}`);
    setActiveTab(newValue);
  };

  return (
    <Stack spacing={4}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="finance report tabs"
        >
          <Tab label="Trial Balance" />
          <Tab label="Balance Sheet" />
          <Tab label="Income Statement" />
          <Tab label="Tithe Contributions" />
        </Tabs>
      </Box>

      <TabPanel value={activeTab} index={0}>
        <GeneralLedgerTable />
      </TabPanel>

      <TabPanel value={activeTab} index={1}>
        <BalanceSheet />
      </TabPanel>

      <TabPanel value={activeTab} index={2}>
        <IncomeStatement />
      </TabPanel>

      <TabPanel value={activeTab} index={3}>
        <TitheContributions />
      </TabPanel>
    </Stack>
  );
};
